/* global Backbone, _ */

'use strict';

var Backbone        = require('backbone');
var _               = require('lodash');
var TailorJobs      = require('./tailor.jobs');
var TailorStart     = require('./tailor.start');
var TailorUpload    = require('./tailor.upload');
var TailorResumable = require('./tailor.resumable');

var _VIDEO_FORMATS = ['3gp','3g2','avi','flv','mov','mp4','m4v','mpeg','mpg','rm','webm','wmv','mxf'];
var _IMAGE_FORMATS = ['jpg','jpeg','gif','png','bmp','tiff','tif','pdf'];

module.exports = Backbone.Model.extend({
    defaults: {
        "actions": [
            {
                "type": "convert",
                "inputs": [
                    {
                        "type": "upload",
                        "reference": "1"
                    }
                ],
                "output_details": [
                    {
                        "identifier": "2",
                        "format": "mp4",
                        "size": {
                            "type": "max_size",
                            "width": 1920,
                            "height": 1080
                        }
                    }
                ]
            },
            {
                "type": "thumbnail",
                "inputs":
                [
                    {
                        "type": "action_result",
                        "reference": "2"
                    }
                ],
                "output_details":
                [
                    {
                        "identifier": "3",
                        "format": "jpeg",
                        "size": {
                            "type": "scale_width",
                            "width": 467
                        },
                        "keyframe": {
                            "type": "percent",
                            "value": 25
                        }
                    }
                ]
            },
            {
                "type": "flex",
                "overrides": [
                    {
                        "name": "video",
                        "inputs": [
                            {
                                "type": "action_result",
                                "reference": "2"
                            }
                        ]
                    },
                    {
                        "name": "image",
                        "inputs": [
                            {
                                "type": "action_result",
                                "reference": "3"
                            }
                        ]
                    }
                ]
            }
        ],
        "imageActions": [
        {
            "type": "transform_image",
            "inputs":
            [
                {
                    "type": "upload",
                    "reference": "1"
                }
            ],
            "output_details":
            [
                {
                    "identifier": "1",
                    "format": "JPEG",
                    "size": {
                        "type": "MAX_AREA",
                        "width": 1920,
                        "height": 1080
                    }
                }
            ]
        },

              {
                  "type": "flex",
                  "overrides": [
                      {
                          "name": "image",
                          "inputs": [
                              {
                                  "type": "action_result",
                                  "reference": "1"
                              }
                          ]
                      }
                  ]
              }
        ],
        "flex": {
            "id": "12312",
            "topics": "1000180",
            "ruleset_collection_id": "1002440",
            "user_name": "Jon DoeFinal",
            "screen_name": "JonDoeFinal",
            "message": "Thumbnail and convert",
            "timestamp": "",
            "image": "",
            "video": "",
            "avatar": "",
            "user_score": "",
            "country": "USA",
            "state": "CA",
            "account_age": "",
            "user_lang": "English",
            "status_lang": "Ready",
            "profile_description": "profile description",
            "user_timezone": "PST",
            "custom_parameters": {}
        },
        "jobId": null,
        "files": []
    },
    optional_fields: [
        //'ruleset_collection_ids', //only needs this to go to tailor
        'screen_name',
        'timestamp',
        'image',
        'video',
        'avatar',
        'user_score'
    ],
    /**
     * Initialize
     * @param  {Object} attrs   [description]
     * @param  {Object} options [description]
     */
    initialize: function(attrs, options) {
        this.auth_token = options.auth_token;
        this.geoCountry = (options.geoCountry)?options.geoCountry:'';
        this.geoState = (options.geoState)?options.geoState:'';
        this.topics = (options.topics)?options.topics:'';
        this.userIP = options.userIP? options.userIP : '';
        this.on('change:files', _.bind(this.onFilesChange, this));

        this.resumable_upload = !_.isUndefined(options.resumableUpload)? options.resumableUpload : true;

        //if endpoints are not specified, default to prod urls
        var endpoints = {
            jobs: 'https://tailor.telescope.tv/1.0/jobs',
            start: 'https://tailor.telescope.tv/1.0/jobs',
            upload: 'https://tailor.telescope.tv/1.0/upload',
            resumable: 'https://tailor.telescope.tv/1.0/resumable_upload/video',
            third_party_cookie_script: 'https://util-dev.telescope.tv/test.php'
        }

        this.endpoints = options.endpoints? _.extend(endpoints, options.endpoints) : endpoints;
    },
    /**
     * [setUpData description]
     * @param  {[type]} data   [description]
     */
    setUpData: function (data) {
        data = _.extend(data, this.get('videoInfo'));

        //map keys per TechOps request
        var keyMap = {
            state: "user_state",
            country: "user_country"
        };

        var newData = {};

        _.each(data, function(value, key){
            key = keyMap[key] || key;
            newData[key] = value;
        });


        data = _.extend(newData, {
            'ip-user': this.userIP || '--',
            akamai_data: {
                state: this.geoState || '--',
                country: this.geoCountry || '--'
            }
        });



        var flex =
        {
            'id': _.uniqueId(new Date().getTime()+''+Math.floor(Math.random()*99)),
            'topics': this.topics,
            'user_name': data.user_name || "--",
            'message': data.message || "--",
            'country': data.country || this.geoCountry,
            'state': data.state || this.geoState,
            'custom_parameters': JSON.stringify(data),
            //'video': data.video,

            'ruleset_collection_id': data.ruleset_collection_id || "0",//this.rulesetCollectionId,
            'ruleset_collection_ids': data.ruleset_collection_ids || "0",//this.rulesetCollectionId,

            'timestamp': new Date().getTime()
        };
        //Populate the optional Flex fields if the form model has matching fields.
        for(var i = 0; i < this.optional_fields.length; i++) {
            var name = this.optional_fields[i];
            var value = data[name];
            if(!_.isUndefined(value) && !_.isNull(value)) {
                flex[name] = value;
            }
        }

        this.set({
            'flex': flex,
            'files': data.file || this.get('files')
        });
    },
    /**
     * [onFilesChange description]
     * @param  {[type]} model   [description]
     * @param  {[type]} value   [description]
     * @param  {[type]} options [description]
     */
    onFilesChange: function(model, value, options) {
        var files = this.get('files');

        if(files) {
            if(files.length > 0) {
                var that = this;
                var hasValidFile = _.filter(files, function(file) {
                    var ext = file.name.split('.').pop().toLowerCase();
                    return _VIDEO_FORMATS.indexOf(ext) > -1 || _IMAGE_FORMATS.indexOf(ext) > -1;
                }).length > 0;

            if(hasValidFile) return;
            }
        }

        this.set({ 'files': null }, { silent: true });
    },
    /**
     * Listens for and handles the form.model 'validated:valid' event.
     * In this case, it starts the Tailor job process.
     * @param {Object}  attrs [description]
     */
    save: function(attrs) {

        //actions
        var actions = [],
        files = this.get('files');
        if(files.length > 0
            && _IMAGE_FORMATS.indexOf(files[0].name.split('.').pop().toLowerCase()) > -1) {
            actions = this.get('imageActions')
        } else if(files.length > 0
            && _VIDEO_FORMATS.indexOf(files[0].name.split('.').pop().toLowerCase()) > -1) {
            actions = this.get('actions')
        }
        var model = new TailorJobs({
            actions: actions,
            flex: this.get('flex')
        }, {
            apiUrl: this.endpoints.jobs,
            auth_token: this.auth_token,
            jobId: this.get('jobId')
        });
        this.listenTo(model, 'sync', _.bind(this.onTailorJobsResponse, this));
        this.listenTo(model, 'error', _.bind(this.onTailorGenericError, this));

        return model.save(); //Submit the job to tailor.
    },
    /**
     * fetch Job Status - poll the endpoint GET /jobs/{job_id}
     * @return {[type]} [description]
     */
    tailorJobStatus: function (jobId) {

      var model = new TailorJobs({}, {
        apiUrl: this.endpoints.jobs,
        auth_token: this.auth_token,
        jobId: jobId,
        poll: true
      });

      this.on('destroy', function(){
        if(model instanceof TailorJobs){
          model.stopPolling();
          model.destroy();
        }
      });
      this.listenTo(model, 'sync', this.onTailorJobStatusResponse.bind(this));
      this.listenTo(model, 'error', _.bind(this.onTailorGenericError, this));
      model.fetch();

    },
    /**
     * TailorJobs.fetch sync handler
     * @param  {[type]} jobModel [description]
     * @param  {[type]} resp     [description]
     * @param  {[type]} options  [description]
     * @return {[type]}          [description]
     */
    onTailorJobStatusResponse: function(jobModel, resp, options) {

      var status = resp.status;
      var actions = _.map(resp.actions, 'status');

      console.log('TailorJobs.fetch sync handler', resp, status, actions)

      this.set({
        job_status_raw: resp,
        job_status_total: status,
        job_status_phased: actions
      })

      if(/finished/i.test(status)){
        this.trigger('status:finished');
        jobModel.stopPolling();
      } else if (/error/i.test(status)) {
        this.trigger('status:error');
        jobModel.stopPolling();
      }
    },
    /**
     * Handles the response from the initial Tailor jobs API call.
     * Starts the upload process if there are no errors.
     * @param {[type]} jobModel [description]
     * @param {[type]} resp [description]
     * @param {Object} options [description]
     */
    onTailorJobsResponse: function(jobModel, resp, options) {
        this.stopListening(jobModel);
        if(jobModel.get('job_id') !== undefined) {
            this.set({'jobId': jobModel.get('job_id')});
            this.trigger('success:jobs', jobModel.attributes);
        } else if(jobModel.get('topics') === this.topics) {
            this.trigger('success:flex', jobModel.attributes);
        } else {
            this.set(resp);
            this.trigger('error', this, resp, options);
            this.trigger('error:jobs', this, resp, options);
        }
    },
    /**
     * [detectionForUploadModel description]
     * @param  {Boolean} hasCookieSupport [description]
     * @return {[type]}                   [description]
     */
    detectionForUploadModel: function (hasCookieSupport) {
      console.log('hasCookieSupport: '+hasCookieSupport);
      console.log('hasBlobConstructorSupport: '+this.constructor.hasBlobConstructorSupport());
      var uploadMethod = 'single';
      if(this.resumable_upload &&
        hasCookieSupport &&
        this.constructor.hasBlobConstructorSupport()) {
        uploadMethod = 'resumable';
      }
      this.makeUploadModel(uploadMethod)
    },
    /**
     * [makeUploadModel description]
     * @param  {[type]} name [description]
     * @return {[type]}      [description]
     */
    makeUploadModel: function (uploadMethod) {
      uploadMethod = uploadMethod || 'single'; // single|resumable
      var jobId = this.get('jobId');
      var files = this.get('files');

      if(files.length > 1) {
          console.warn('Tailor currently only supports one file upload at a time.  Only the first input:file will be uploaded.');
      }

      var uploadModel;

      if(uploadMethod==='resumable' && this.constructor.isVideo(files[0].name)) {
          uploadModel = new TailorResumable({
              upload: files[0],
              jobId: jobId
          }, {
              apiUrl: this.endpoints.resumable,
              // apiUrl: this.endpoints.upload,
              auth_token: this.auth_token,
              videoUpload: this.constructor.isVideo(files[0].name) //Access the "static" methods defined at bottom.
          });

          this.listenTo(uploadModel, 'upload-complete', _.bind(this.onTailorUploadResponse, this));

          this.listenTo(uploadModel, 'change:upload_phase', function(model, value){ this.set('upload_phase', value) }.bind(this));
          this.listenTo(uploadModel, 'change:chunk_count', function(model, value){ this.set('chunk_count', value) }.bind(this));
          this.listenTo(uploadModel, 'change:chunk_index', function(model, value){ this.set('chunk_index', value) }.bind(this));

          this.listenTo(uploadModel, 'upload-error', _.bind(this.onTailorGenericError, this));
      } else {
          uploadModel = new TailorUpload({
              upload: files[0],
              jobId: jobId
          }, {
              // apiUrl: this.endpoints.resumable,
              apiUrl: this.endpoints.upload,
              auth_token: this.auth_token,
              videoUpload: this.constructor.isVideo(files[0].name) //Access the "static" methods defined at bottom.
          })

          this.listenTo(uploadModel, 'sync', _.bind(this.onTailorUploadResponse, this));
          this.listenTo(uploadModel, 'error', _.bind(this.onTailorGenericError, this));
          this.set('chunk_count', 1);
      }

      //Progress bar listener.
      var that = this;
      var options = {
          beforeSend: function(xhr, settings) {
              settings.xhr = function() {
                  var xhr = Backbone.$.ajaxSettings.xhr();
                  xhr.upload.addEventListener("progress", _.bind(that.onTailorUploadProgress, that));
                  return xhr;
              }
          },
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          }
      }

      uploadModel.save({}, options);
    },
    /**
     * [tailorUpload description]
     * @return {[type]} [description]
     */
    tailorUpload: function() {

        if(!this.resumable_upload){
          this.makeUploadModel('single');
          return;
        }

        this.isSupportedThirdPartyCookies().then(this.detectionForUploadModel.bind(this), this.detectionForUploadModel.bind(this));
    },
    /**
     * Handles the response from the Tailor upload API call.
     * Starts the conversion job if there are no errors.
     * @param {[type]} uploadModel [description]
     * @param {[type]} resp [description]
     * @param {Object} options [description]
     */
    onTailorUploadResponse: function(uploadModel, resp, options) {
        this.stopListening(uploadModel);
        if(uploadModel.get('status') === 200) {
            this.trigger('success:upload', this, resp, options);
        } else {
            this.set(resp);
            this.trigger('error', this, resp, options);
            this.trigger('error:upload', this, resp, options);
        }
    },
    /**
     * [tailorStart description]
     * @return {[type]} [description]
     */
    tailorStart: function() {
        var options = {
            apiUrl: this.endpoints.start,
            auth_token: this.auth_token,
            job_id: this.get('jobId')
        };

        var startModel = new TailorStart( {}, options );
        this.listenTo(startModel, 'sync', _.bind(this.onTailorStartResponse, this));
        this.listenTo(startModel, 'error', _.bind(this.onTailorGenericError, this));

        startModel.save();
    },
    /**
     * Updates the loading model with the upload process if the browser supports
     * the xhr.onprogress event.
     * @param {event} evt - A reference to the 'progress' event object.
     */
    onTailorUploadProgress: function(evt) {
        this.trigger('progress', this, evt);
    },
    /**
     * Handles generic errors triggered by the Tailor process.
     * @param {[type]} model   [description]
     * @param {[type]} resp    [description]
     * @param {object} options - jQuery error stuff?
     */
    onTailorGenericError: function(model, resp, options) {
        var errorCodes = model.get('errorCodes');
        //view.model.trigger('validated:invalid');
        this.trigger('error', model, resp, options);
    },
    /**
     * Handles the response from the Tailor start API call.
     * @param {[type]} startModel [description]
     * @param {[type]} resp [description]
     * @param {Object} options [description]
     */
    onTailorStartResponse: function(startModel, resp, options) {
        this.set(resp);
        if(startModel.get('job_id') !== undefined) {
            this.set({'jobId': null});
            this.trigger('sync', this, resp, options, startModel.get('job_id'));
        } else {
            this.trigger('error', this, resp, options);
            this.trigger('error:start', this, resp, options);
        }
    },
    /**
     * [isSupportedThirdPartyCookies description]
     * @return {Boolean} [description]
     */
    isSupportedThirdPartyCookies: function ( ) {

      var defer = this.testThirdPartyCookies;
      if(!defer) {
        defer = this.testThirdPartyCookies = Backbone.$.Deferred();
        var opts = {
          method: 'POST',
          url: this.endpoints.third_party_cookie_script,
          dataType: 'json',
          crossDomain: true,
          cache: false,
          xhrFields: {
            withCredentials: true
          }
        };
        var cbError = function( jqXHR, textStatus, errorThrown ) {
          defer.reject(false);
        }.bind(this);
        var cbPhase1 = function( data, textStatus, jqXHR ) {
          _.extend(opts, {url: this.endpoints.third_party_cookie_script+'?phase=2'})
          Backbone.$.ajax(opts).then(cbPhase2, cbError);
        }.bind(this);
        var cbPhase2 = function( data, textStatus, jqXHR ) {
          console.log('cbPhase2', data, textStatus, jqXHR);
          var status = (!_.isUndefined(data.THIRD_PARTY_COOKIE) && data.THIRD_PARTY_COOKIE==='true');
          defer.resolve(status);
        }.bind(this);

        _.extend(opts, {url: this.endpoints.third_party_cookie_script+'?phase=1'})
        Backbone.$.ajax(opts).then(cbPhase1, cbError);
      }

      return defer.promise();

    }
}, {
    //STATIC METHODS
    getSupportedVideoTypes: function() {
        return _.clone(_VIDEO_FORMATS);
    },

    getSupportedImageTypes: function() {
        return _.clone(_IMAGE_FORMATS);
    },

    isSupportedVideoType: function(fileName) {
        var ext = fileName.split('.').pop().toLowerCase();
        return (_VIDEO_FORMATS.indexOf(ext) > -1);
    },

    isSupportedImageType: function(fileName) {
        var ext = fileName.split('.').pop().toLowerCase();
        return (_IMAGE_FORMATS.indexOf(ext) > -1);
    },

    isImage: function(fileName) {
        return this.isSupportedImageType(fileName);
    },

    isVideo: function(fileName) {
        return this.isSupportedVideoType(fileName);
    },

    hasFileAPISupport: function () {
        // this is how Modernizr tests for the File API specification
        // (https://github.com/Modernizr/Modernizr/blob/master/feature-detects/file/api.js)
        return !!(window.File && window.FileList && window.FileReader);
    },

    hasFileAPISliceSupport: function () {
        return !!(window.File && (window.File.prototype.slice || window.File.prototype.mozSlice || window.File.prototype.webkitSlice));
    },

    hasBlobConstructorSupport: function () {
      try {
        return !!new Blob();
      } catch (e) {
        return false;
      }
    }
});
